export enum SaleMethodVo {
  Cash = 'CASH',
  Ticket = 'TICKET',
}
